module.exports = __webpack_public_path__ + "static/fuji_sagres.resized-239a3a1b632823f937a73bcfd8554205.jpg";